import { render, staticRenderFns } from "./BaseH3.vue?vue&type=template&id=6b033a59&"
import script from "./BaseH3.vue?vue&type=script&lang=js&"
export * from "./BaseH3.vue?vue&type=script&lang=js&"
import style0 from "./BaseH3.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports